
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic02 as ObiLogic02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-02.js';
 
 
 

 
 export const ObiLogic02 = createComponent({
   react: React,
   tagName: 'obi-logic-02',
   elementClass: ObiLogic02Element,
   events: {
     
   }
  });
 
 